import {
  EMAIL,
  PERMISSION,
  STORE_ID,
} from './fields';

export default function payload() {
  return {
    email: {
      field: EMAIL,
    },
    permission: {
      field: PERMISSION,
    },
    store_id: {
      field: STORE_ID,
    },
  };
}
